import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import {
  KeyboardDoubleArrowUp,
  KeyboardDoubleArrowDown,
} from "@mui/icons-material";
import { useFormHandlerContext } from "../../../controllers/formController";

const AttributeToggleControl: React.FC = () => {
  const { areAllMetadataVisible, toggleAllMetadataVisibility } =
    useFormHandlerContext();

  return (
    <Tooltip
      title={
        areAllMetadataVisible ? "Hide All Metadata" : "Display All Metadata"
      }
    >
      <IconButton onClick={toggleAllMetadataVisibility} color="primary">
        {areAllMetadataVisible ? (
          <KeyboardDoubleArrowUp />
        ) : (
          <KeyboardDoubleArrowDown />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default AttributeToggleControl;
